
// n=number of decimals
// x=number of comma-delimited digits (default 3), ie 123,123
const format = (value, n, x) => {
  let re = `\\d(?=(\\d{${  x || 3  }})+${  n > 0 ? '\\.' : '$'  })`;
  return value.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

export const getDelimitedValue = (val, dec, delimitDigits) => {
  return val === 0 || val === undefined || val === null ? 0 : format(val, dec, delimitDigits);
};

export const displayPointsValue = (val) => {
  return `${getDelimitedValue(val, 0, 3)} ${parseInt(val) === 1 ? 'pt' : 'pts'}`;
};

export const currencyFormatter = ({ value }) => {
  if (value || value === 0) {
    if (Number.isInteger(value)) {
      return `$${  format(value)}`;
    } else {
      return `$${  format(value, 2, 3)}`;
    }
  }
  return '';
};

const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const amountFormatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatWith = (formatter, value) => {
  if (value === null || value === undefined || value === '') return '';
  const amount = typeof value === 'number' ? value : Number(String(value).replace(/[$,\s]/g, ''));
  return Number.isFinite(amount) ? formatter.format(amount) : String(value);
};

// Display only (never an input's value): 12345.6 or '12345.6' -> '$12,345.60'.
// Text that isn't a number is returned as-is, and empty values return ''.
export const formatMoney = value => formatWith(usdFormatter, value);

// Same as formatMoney without the '$' (12345.6 -> '12,345.60'), for amounts whose currency is shown separately.
export const formatAmount = value => formatWith(amountFormatter, value);

// Starting value for a money input: adds the missing cent digit (1002.5 -> '1002.50'). Whole dollars (1500),
// values already at two or more decimals, empty and non-numeric values pass through unchanged, so saving an
// untouched field can't change it. Use through useMoneyInputs so padding stops once the user types.
export const toMoneyInputValue = value => {
  if (value === null || value === undefined || value === '') return value;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return value;
  const decimals = (String(value).split('.')[1] || '').length;
  return decimals === 1 ? amount.toFixed(2) : value;
};

// copied from transferee, should refactor currencyFormatter into single function
export const bareCurrencyFormatter = ({ value, showDollarSign }) => {
  if (value || value === 0) {
    return showDollarSign ? '$' : `${  format(value, 2, 3)}`;
  }
  return '';
};

// allow search for currency with dollar signs
// return true if match found for either $value or value
export const currencyFilterPredicate = (value, filter) => {
  return filter.value ?
    value.toString().indexOf(filter.value) > -1 || (`$${  value}`).indexOf(filter.value) > -1
    : false;
};

export default { currencyFormatter, getDelimitedValue, currencyFilterPredicate };